import React, {Component} from 'react';
import {FormControl, MenuItem} from "@mui/material";
import {CustomArrow, CustomSelect} from "./styles";

class SelectBox extends Component {

    componentDidMount() {
        if (this.props.load) {
            this.props.load();
        }
    }

    render() {
        return (
            <FormControl>
                <CustomSelect
                    className={`${this.props.className ? this.props.className + " editorial-table-select-inner" : ""}`}
                    onChange={this.props.handleChangeSelect}
                    value={this.props.selectValue}
                    IconComponent={() => !this.props.hideArrow && (<CustomArrow/>)}
                    MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                >
                    {this.props.showDefault && (
                        <MenuItem value="" disabled>Please select an option</MenuItem>
                    )}
                    {this.props.selectArray.length > 0 ?
                        this.props.selectArray.map((x, y) => <MenuItem key={y} value={x.value}>{x.label}</MenuItem>) :
                        <MenuItem value="" disabled>Please select an option</MenuItem>
                    }
                </CustomSelect>
            </FormControl>
        )
    }
}

export default SelectBox;
